import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Dashboard from "../SalesMasterPages/Dashboard/Dashboard";

function LeadTransfer() {
  let navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [country, setCountry] = useState(null);
  const [firstItem, setFirstItem] = useState(null);
  const [petDetail, setPetDetail] = useState([]);
  const [petBreed, setPetBreed] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({ relocation_id: "" });

  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const Admin = localStorage.getItem("isAdmin") === "true";
    setIsAdmin(Admin);
  }, []);

  const handleInputChange = (e) => {
    const { value, name } = e.target;
    setFormData({ relocation_id: value });
  };

  const getCurrentIdDetails = (e) => {
    e.preventDefault();
    setLoading(true);
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (baseAPI.includes("aeapi")) {
      setCountry("India");
    } else {
      setCountry("Dubai");
    }
    axios
      .get(
        `${baseAPI}userget/GetLeadDetail?relocation_id=` +
          formData.relocation_id,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        setFirstItem(response.data.data);
        setPetDetail(response.data.data.petsDetail);
        getPetBreed(
          response.data.data.petsDetail[0].pet_type,
          response.data.data.petsDetail[0].pet_breed
        );
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  };

  console.log(isAdmin);

  function getPetBreed(pet_type, pet_breed) {
    if (pet_type === null || pet_type === "") {
      pet_type = 0;
    }

    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GEPetBreedType?PetBreedID=0&PetType=` + pet_type,
        {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        }
      )
      .then((response) => {
        console.log(response.data.data);
        response.data.data.map((item) => {
          if (item.id == pet_breed) {
            setPetBreed(item.PetBreedType);
          }
        });
      });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const storedToken = JSON.parse(localStorage.getItem("token"));
    try {
      if (country === "India") {
        const response = await axios.post(
          `${baseAPI}AdminPost/TransferLeadToIndia`,
          formData,
          {
            headers: {
              Authorization: "Bearer " + storedToken,
            },
          }
        );
        alert(
          `Lead Transferred Successfully. New Relocation ID is ${response.data.data.RelocationID}`
        );
      } else {
        const response = await axios.post(
          `${baseAPI}AdminPost/TransferLeadToDubai`,
          formData,
          {
            headers: {
              Authorization: "Bearer " + storedToken,
            },
          }
        );
        alert(
          `Lead Transferred Successfully. New Relocation ID is ${response.data.data.RelocationID}`
        );
      }
      setFirstItem(null);
      setFormData({ relocation_id: "" });
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };


  const transferUntouchedLead = async (e) => {
    e.preventDefault();
    const storedToken = JSON.parse(localStorage.getItem("token"));
    try {      
        const response = await axios.post(
          `${baseAPI}AdminPost/TransferUntouchedLead`,
          formData,
          {
            headers: {
              Authorization: "Bearer " + storedToken,
            },
          }
        );
        alert(
          `Untouched Lead Transferred Successfully. New Relocation ID is ${response.data.data.RelocationID}`
        );      
      setFirstItem(null);
      setFormData({ relocation_id: "" });
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  if (isAdmin) {
    return (
      <div className="mt-3 px-4">
        <form>
          <table className="leadlist_1">
            <tbody>
              <tr className="viewLeadDetailsHeading">
                <th className="text-start px-4 py-4">
                  <input
                    onChange={handleInputChange}
                    style={{
                      width: "22%",
                      borderRadius: "7px",
                      padding: "10px",
                    }}
                    type="number"
                    name="relocationID"
                    value={formData.relocation_id}
                    placeholder="Enter Your Reolcation ID"
                  />
                  <button
                    style={{
                      height: "46px",
                      width: "121px",
                      marginLeft: "10px",
                    }}
                    type="submit"
                    onClick={getCurrentIdDetails}
                  >
                    View Details
                  </button>
                </th>
                <td></td>
              </tr>
            </tbody>
          </table>
        </form>
        {loading ? (
          <h4 className="py-3" style={{ fontSize: "17px" }}>
            Loading...
          </h4>
        ) : (
          <>
            {firstItem ? (
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  border: "1px solid #DEE2E6",
                }}
              >
                <table className="leadlist_1">
                  <tbody>
                    <tr className="viewLeadDetailsHeading expenseHeading">
                      <th>
                        <span>Relocation ID</span>
                      </th>
                      <td>
                        <span>{firstItem.relocation_id}</span>
                      </td>
                      <th>
                        <span>Name</span>
                      </th>
                      <td style={{ borderBlock: "1px solid #ccc" }}>
                        <span>{firstItem.first_name}</span>
                      </td>
                    </tr>
                    <tr className="viewLeadDetailsHeading">
                      <th>
                        <span>Contact Number</span>
                      </th>
                      <td>
                        {firstItem && firstItem.mobile_no ? (
                          <span>{firstItem.mobile_no}</span>
                        ) : null}
                      </td>
                      <th>
                        <span>Email</span>
                      </th>
                      <td>
                        <span>{firstItem.email}</span>
                      </td>
                    </tr>
                    <tr className="viewLeadDetailsHeading">
                      <th>
                        <span>Pet Type</span>
                      </th>
                      <td>
                        <span>{firstItem.pettype}</span>
                      </td>
                      <th>
                        <span>Pet Breed</span>
                      </th>
                      {petBreed ? (
                        <td>
                          <span>{petBreed}</span>
                        </td>
                      ) : null}
                    </tr>
                    <tr className="viewLeadDetailsHeading">
                      <th>
                        <span>Number of Pets</span>
                      </th>
                      <td>
                        <span>{firstItem.number_of_pets}</span>
                      </td>
                      <th>
                        <span>Origin Country</span>
                      </th>
                      <td>
                        <span>{firstItem.origin_country1}</span>
                      </td>
                    </tr>
                    <tr className="viewLeadDetailsHeading">
                      <th>
                        <span>Origin State</span>
                      </th>
                      <td>
                        <span>{firstItem.origin_state1}</span>
                      </td>
                      <th>
                        <span>Origin City</span>
                      </th>
                      <td>
                        <span>{firstItem.origin_city1}</span>
                      </td>
                    </tr>
                    <tr className="viewLeadDetailsHeading">
                      <th>
                        <span>Destination Country</span>
                      </th>
                      <td>
                        <span>{firstItem.destination_country1}</span>
                      </td>
                      <th>
                        <span>Destination State</span>
                      </th>
                      <td>
                        <span>{firstItem.destination_state1}</span>
                      </td>
                    </tr>
                    <tr className="viewLeadDetailsHeading">
                      <th>
                        <span>Destination City</span>
                      </th>
                      <td>
                        <span>{firstItem.destination_city1}</span>
                      </td>
                      <th>
                        <span></span>
                      </th>
                      <td>
                        <span></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : null}
            {firstItem ? (
              <div className="px-0 py-3 text-end">
                {/* <button style={{ margin:"15px",width: "192px" }} onClick={handleSubmit}>
                  Transfer Converted Lead To {country}
                </button> */}
                <button
                  style={{ width: "192px" }}
                  onClick={transferUntouchedLead}
                >
                  Transfer Untouched Lead To {country}
                </button>
              </div>
            ) : null}
          </>
        )}
      </div>
    );
  } else {
    return <Dashboard />;
  }
}

export default LeadTransfer;
